/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Dietician_LeadInputs */

const en_for_whom_dietician_lead = /** @type {(inputs: For_Whom_Dietician_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target, meals and macros.`)
};

const pl_for_whom_dietician_lead = /** @type {(inputs: For_Whom_Dietician_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cel, posiłki i makro.`)
};

/**
* | output |
* | --- |
* | "Target, meals and macros." |
*
* @param {For_Whom_Dietician_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_dietician_lead = /** @type {((inputs?: For_Whom_Dietician_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Dietician_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_dietician_lead(inputs)
	return en_for_whom_dietician_lead(inputs)
});